import { formatujDateZGodzinaIDniemTygodniaPoPolsku } from "actions/formatujDateZGodzinaIDniemTygodniaPoPolsku";
import style from "../ProcesViewRow.module.css";
import { druk_alert } from "actions/druk_alert";
import DecodeToken from "pages/Login/DecodeToken";


export default function Dzien ({ grup,style }) {


  return (
    
                  <td  title={ JSON.stringify(grup, null, 5)}  className={druk_alert(grup) ? style.td_tableProcesy_poczatek_alert_dzien: style.td_tableProcesy_poczatek_dzien}>{formatujDateZGodzinaIDniemTygodniaPoPolsku(grup.poczatek)}</td>

  );
};


